module.exports = __webpack_public_path__ + "static/media/no_pleats.431f425f.svg";